export default __webpack_public_path__ + "static/media/WAS0450.34I-40967_-24783_0.9b0d17fe.jpg";